import { createRoot } from 'react-dom/client';
import App from './App';
import React, { StrictMode, Suspense } from 'react';
import Loading from './components/ui/loading';
import './index.css';
import { QueryContext } from '@/components/Contexts/QueryContext';
import {
  NotificationProvider
} from '@/components/Contexts/NotificationContext.tsx';
import {Toaster} from '@/components/ui/sonner.tsx';
import ProgressDialog from '@/components/compositions/progress-dialog.tsx';
import { ThemeProvider } from '@/components/Contexts/ThemeContext';

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <ThemeProvider>
        <Suspense fallback={<Loading message="Starting application..." />}>
          <QueryContext>
            <NotificationProvider>
              <ProgressDialog />
              <>
                <Toaster richColors />
                <App/>
              </>
            </NotificationProvider>
          </QueryContext>
        </Suspense>
      </ThemeProvider>
    </StrictMode>
  );
}
